import { createContext } from "react";

const JobsContext = createContext({})

export default JobsContext;
